import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimeDisplay from './DateTimeDisplay';
import Avatar from './Avatar';

export default class NotificationsListItem extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
    timezone: PropTypes.string,
    onClick: PropTypes.func,
    isAnnoucement: PropTypes.bool,
    isFeedbackReminder: PropTypes.bool,
    isAboutEvent: PropTypes.bool,
    isAboutEventRsvp: PropTypes.bool,
    isModalTrigger: PropTypes.bool,
    event: PropTypes.object,
    eventRsvp: PropTypes.object,
    pending_requests: PropTypes.number,
    onMarkAsRead: PropTypes.func,
    read: PropTypes.bool,
    css: PropTypes.string,
    author: PropTypes.shape({
      avatar: PropTypes.string,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    timezone: moment.tz.guess(),
    onClick() {},
    onMarkAsRead() {},
    isAnnoucement: false,
    isFeedbackReminder: false,
    isAboutEvent: false,
    isAboutEventRsvp: false,
    isModalTrigger: false,
    event: {},
    eventRsvp: {},
    pending_requests: 0,
    read: false,
    css: '',
  }

  handleMarkAsRead = (e) => {
    e.preventDefault();
    this.props.onMarkAsRead();
  }

  render() {
    const readModifier = this.props.read ? '' : 'Popover-item--unread';

    let thumbnail;

    if (this.props.isFeedbackReminder) {
      thumbnail = (
        <Avatar
          className="Popover-item-avatar"
          src={this.props.author.avatar}
          name={`${this.props.pending_requests}`}
          type={this.props.author.type}
        />
      );
    } else if (this.props.isAboutEvent || this.props.isAboutEventRsvp) {
      const startDate = moment(this.props.event.start_date);
      thumbnail = (
        <div className="u-border-blue u-bg-white u-mr-3 u-flex u-flex-col u-flex-shrink-0 u-w-12 u-h-12 u-border-3 u-justify-center u-items-center u-rounded-sm">
          <span className="u-text-lg u-leading-none u-align-bottom">{startDate.format('DD')}</span>
          <span className="u-uppercase u-text-xs u-align-top">{startDate.format('MMM')}</span>
        </div>
      );
    } else {
      thumbnail = (
        <Avatar
          className="Popover-item-avatar"
          src={this.props.author.avatar}
          name={this.props.author.name}
          type={this.props.author.type}
        />
      );
    }

    return (
      <a href={this.props.linkUrl} className={`Popover-item Popover-item--clickable ${readModifier} ${this.props.css}`} onClick={this.props.onClick}>
        <div className="u-flex u-items-start">
          { thumbnail }
          <div>
            <span className="Popover-item-title">
              {this.props.title}
            </span>
            <span className="u-mx-1">
              ·
            </span>
            <span className="Popover-item-timestamp">
              {this.props.timestamp} ago
            </span>
          </div>
        </div>
        <span className="Popover-read-status" onClick={this.handleMarkAsRead} />
      </a>
    );
  }
}
